import script from "./BoosterCcsHistory.vue?vue&type=script&setup=true&lang=js"
export * from "./BoosterCcsHistory.vue?vue&type=script&setup=true&lang=js"

import "./BoosterCcsHistory.vue?vue&type=style&index=0&id=bed447ac&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bed447ac"]])

export default __exports__